module.exports = __webpack_public_path__ + "images/alipay-c5847c776e7ba26b388cf3bbc0df5f25.png";